import React from 'react';
import { AccessType } from 'src/constants';
import { hasAccess } from 'src/libraries/access.library';

type IProps = {
  type: AccessType;
  when?: boolean;
};

const Access: React.FC<IProps> = ({ type, when = true, children }) => {
  if (hasAccess(type) && when) {
    return <>{children}</>;
  }

  return null;
};

export { AccessType };

export default Access;
